import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const SpecialOffersSection = styled.section`
    border-top: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('gray200')};
    padding: ${getPurpurSpacing('600')} 0; // ToDo: in CCD scope top padding is 200 ( LTCONT-23319 )
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;

export const SpecialOffersSectionTitle = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('100')};
`;
